import React from 'react'
import { Link } from 'react-router-dom'
import { Info, ArrowRight } from 'lucide-react'
import styles from './SMCoverageNudge.module.css'

// Sits between the two setup states: has_occasion_data is true (so the
// full page renders) but clients_with_occasion < total_clients — most
// clients still have no birthday/anniversary on file. A quiet nudge,
// not a blocker, since the feature already works for the ones that do.
const SMCoverageNudge = ({ clientsWithOccasion, totalClients }) => (
    <Link to="/manage/clients" className={styles.nudge}>
        <Info size={15} className={styles.icon} />
        <span className={styles.text}>
            <strong>{clientsWithOccasion}</strong> of <strong>{totalClients}</strong> clients have a birthday or anniversary
            on file — add more to catch every celebration.
        </span>
        <ArrowRight size={13} className={styles.arrow} />
    </Link>
)

export default SMCoverageNudge
